/* istanbul ignore file */
import _ from 'underscore';
import { i18nMap, safeGetString } from '../i18n-map/index';
import { MtErrorCode } from '../i18n-map/mt-errors';

export const createMtError = (errorCode, fieldName) => ({
  ErrorCode: errorCode,
  FieldName: fieldName,
});

export const createResponseError = (
  httpStatusCode,
  httpBody,
  httpStatusText,
  httpResponseText,
  httpErrors
) => {
  const error = {
    status: httpStatusCode,
    raw: httpBody,
    responseText: httpResponseText,
    statusText: httpStatusText,
    errors: httpErrors,
  };
  return error;
};

export const splitAndConvertToArray = (sourceString, delimiterRegex) =>
  // split, trim, remove empty entrys
  (sourceString ? _.filter(
    _.map(
      sourceString.split(delimiterRegex),
      item => item.trim()
    ),
    item => item
  ) : []);

export const createError = (code, i18n, fieldName) => {
  let errorCode;
  if (!code) {
    errorCode = MtErrorCode.InternalServerError;
    window.console.log('ErrorCode null or undefined.');
  } else {
    errorCode = code;
  }

  return {
    Code: errorCode,
    LocalizedMessage: safeGetString(i18n, i18nMap.MtErrorMessages, errorCode),
    FieldName: fieldName,
  };
};

export const getResponseErrors = (response, i18n) => {
  if (response) {
    if (response.status === 400 || response.status === 403 || response.status === 404) {
      if (_.isArray(response.raw)) {
        return _.map(response.raw, item => createError(item.ErrorCode, i18n, item.FieldName));
      }
      if (response.raw && response.raw.Code) {
        return [createError(response.raw.Code, i18n, response.raw.FieldName)];
      }
      return [createError(MtErrorCode.UnknownError, i18n)];
    } else if (response.status === 401) {
      return [createError(MtErrorCode.Unauthorized, i18n)];
    }
  }

  window.console.log(JSON.stringify(response));
  return [createError(MtErrorCode.InternalServerError, i18n)];
};
